<template lang="jade">
  .loading.center-element
    span.msg.center-element
      h3 Aguarde
      pulse-loader
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  components: {
    PulseLoader
  }
}
</script>

<style scoped>
  .loading {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.2);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10000;
  }

  h3 {
    margin: 0px;
    margin-right: 50px;
  }

  .msg {
    position:absolute;
    width:100%;
    color: white;
    height:50px;
    background: rgb(100, 100, 100);
    bottom:0px;
  }
</style>



// WEBPACK FOOTER //
// Loading.vue?a738cfa8